import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";

import AttachmentForm from "./AttachmentForm";
import LinkForm from "./LinkForm";

const forms = {
  attachment: AttachmentForm,
  link: LinkForm
};

export default function Create({
  attachmentTypes,
  close,
  multiple = false,
  open,
  referenceOptions,
  resourceId,
  resourceType,
  type
}) {
  const Form = forms[type];

  return (
    <div>
      <Modal open={open} close={close} dialogClass="modal-sm">
        <Header>
          <Close close={close} />
          <h4 className="modal-title">
            Add a {type === "link" ? "Link" : "File"}
          </h4>
        </Header>
        <Form
          resourceType={resourceType}
          resourceId={resourceId}
          close={close}
          attachmentTypes={attachmentTypes}
          multiple={multiple}
          referenceOptions={referenceOptions}
        />
      </Modal>
    </div>
  );
}

Create.propTypes = {
  attachmentTypes: PropTypes.instanceOf(Object),
  close: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  referenceOptions: PropTypes.shape({}),
  resourceId: PropTypes.number.isRequired,
  resourceType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Attachments/Create.jsx